<template>
    <div class="history-missions-list">
        <div v-for="mission in missions" :key="mission.id" class="history-missions-item">
            <MissionHistoryRow :mission="mission" />
        </div>
    </div>
</template>

<script>
import MissionHistoryRow from './MissionHistoryRow.vue'


export default {
    props: ['missions'],
    components: {
        MissionHistoryRow
    },
}
</script>

<style scoped>
.history-missions-list {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    padding: 0.45rem 0;
}

.history-missions-item {
    min-width: 0;
}
</style>